// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__d767j","header":"ReportDetails_header__2-jk1","title":"ReportDetails_title__3xL0U","left":"ReportDetails_left__3puKo"};